import { Consumer, Discount as DiscountApi } from '@vendasta/billing';
import { discountTypeFromApi, DiscountType } from './discount_type';

export interface Discount {
  discountId: number;
  id: string;
  discountType: DiscountType;
  amount: number;
  start?: Date;
  end?: Date;
  resetEachPeriod: boolean;
  merchantId: string;
  created?: Date;
  updated?: Date;
  SKU: string;
  description: string;
  customerId?: string;
  consumer?: Consumer;
  subscriptionId?: string;
  numberOfBillingPeriods: number;
}

export function discountFromApi(apiDiscount: DiscountApi): Discount {
  return {
    merchantId: apiDiscount.merchantId || '',
    discountId: apiDiscount.discountId || 0,
    id: apiDiscount.id || '',
    discountType: discountTypeFromApi(apiDiscount.discountType),
    amount: apiDiscount.amount || 0,
    start: apiDiscount.start ? new Date(apiDiscount.start) : undefined,
    end: apiDiscount.end ? new Date(apiDiscount.end) : undefined,
    resetEachPeriod: apiDiscount.resetEachPeriod || false,
    created: apiDiscount.created ? new Date(apiDiscount.created) : undefined,
    updated: apiDiscount.updated ? new Date(apiDiscount.updated) : undefined,
    SKU: apiDiscount.sku || '',
    description: apiDiscount.description || '',
    customerId: apiDiscount.customerId || '',
    consumer: apiDiscount.consumer || Consumer.CONSUMER_RETAIL,
    subscriptionId: apiDiscount.subscriptionId || '',
    numberOfBillingPeriods: apiDiscount.numberOfBillingPeriods ?? 0,
  };
}
